import { createRef, useEffect } from 'react'
import { Box } from '@mui/material'
import { useFormikContext, useField } from 'formik'
import { useTranslation } from 'react-i18next'

import DropDownMenu from 'src/components/shared/DropDownMenu/DropDownMenu'
import { fieldsetTableStyles as styles } from 'src/components/shared/styles/FieldsetTableStyles'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import InputFileButton from 'src/components/shared/ui/form/fields/InputFileButton'
import { useAlertContext } from 'src/contexts/AlertContext'
import {
  excesoCabidaFileName,
  excesoCabidaSubTipoObject
} from 'src/components/views/EscritosLexnet/components/shared/components/Adjuntos/components/const'
import DocumentosAnexosTable from 'src/components/views/EscritosLexnet/components/shared/components/Adjuntos/components/tables/DocumentosAnexosTable'
import { LexonDocuments } from 'src/components/views/EscritosLexnet/components/shared/components/LexonDocuments'
import { FormField } from 'src/enums/Form'
import { Orden } from 'src/interfaces/Catalog'
import { DocumentoAnexoType, SubTipoDocumento } from 'src/interfaces/EscritosLegales'
import { LexonDocumentsRefType } from '../../LexonDocuments/components/LexonDocuments'

function DocumentosAnexos(): JSX.Element {
  const { t } = useTranslation()
  const { addAlert } = useAlertContext()

  const [documentosAnexosArchivo] = useField(FormField.DOCUMENTOS_ANEXOS_ARCHIVO)
  const [documentosAnexos, documentosAnexosMeta] = useField(FormField.DOCUMENTOS_ANEXOS)

  const { setFieldValue } = useFormikContext()

  const [orden] = useField<Orden>(
    `${FormField.ORGANO_DESTINO}.${FormField.ORGANO_DESTINO_ORDEN_JUDICIAL}`
  )

  useEffect(
    () => {
      if (typeof documentosAnexosMeta.error === 'string' && documentosAnexosMeta.error !== '') {
        addAlert({ message: documentosAnexosMeta.error, type: AlertType.ERROR })
      }
    },
    // eslint-disable-next-line
    [documentosAnexosMeta.error]
  )

  const refLexonDocuments = createRef<LexonDocumentsRefType>()

  useEffect(
    () => {
      if (documentosAnexosArchivo.value.length > 0) {
        const data: DocumentoAnexoType[] = []
        documentosAnexosArchivo.value.forEach((doc, i) => {
          if (
            documentosAnexos.value[i] &&
            !documentosAnexosArchivo.value[i].file.name.startsWith(excesoCabidaFileName)
          ) {
            data.push(documentosAnexos.value[i])
          } else {
            data.push({
              archivo: doc.file.name,
              subtipo: documentosAnexosArchivo.value[i]?.file?.name.startsWith(excesoCabidaFileName)
                ? (excesoCabidaSubTipoObject as SubTipoDocumento)
                : null,
              descripcion: null,
              hash: doc.hash
            })
            setFieldValue(FormField.DOCUMENTOS_ANEXOS, data)
          }
        })
        setFieldValue(FormField.DOCUMENTOS_ANEXOS, data)
      } else {
        setFieldValue(FormField.DOCUMENTOS_ANEXOS, [])
      }
    },
    // eslint-disable-next-line
    [documentosAnexosArchivo.value, setFieldValue]
  )

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.actions} display="flex" justifyContent="flex-end" alignItems="center">
        <Box component="span" flex="1 1 auto" sx={styles.actionsInfo}>
          {t('form.legend.documentos_anexos')}
        </Box>
        <DropDownMenu
          id="documentos-anexos"
          title={t('form.button.add')}
          items={[
            {
              title: t('form.button.addNew'),
              onClick: () => {
                document.getElementById(FormField.DOCUMENTOS_ANEXOS_ARCHIVO)?.click()
              },
              disabled: !orden.value
            },
            {
              title: t('form.button.addFromLexon'),
              onClick: () => {
                refLexonDocuments?.current?.open()
              },
              disabled: !orden.value
            }
          ]}
        />
      </Box>
      <DocumentosAnexosTable />
      <div style={{ display: 'none' }}>
        <InputFileButton
          id={FormField.DOCUMENTOS_ANEXOS_ARCHIVO}
          multiple
          disabled={!orden.value}
        />
      </div>
      <LexonDocuments
        id={FormField.DOCUMENTOS_ANEXOS_ARCHIVO}
        ref={refLexonDocuments}
        principal={false}
        disabled={!orden.value}
      />
    </Box>
  )
}

export default DocumentosAnexos
